import React, { IframeHTMLAttributes } from 'react';

function PDFViewer( props : IframeHTMLAttributes<any> ) {
  return (
    <iframe
      {...props}
      title="FILE Viewer"
    />
  );
}

export default PDFViewer;
